






import { Vue, Component, Prop } from 'vue-property-decorator';
import { ESlideOrigin } from './enums/slide-origin';

@Component({
  name: 'TransitionSlideInOut',
})
export default class TransitionSlideInOut extends Vue {
  @Prop({ default: ESlideOrigin.Bottom }) origin: ESlideOrigin;
}
